export default __webpack_public_path__ + "static/media/VL_logo_black.0254d3fe.PNG";